import { render } from "./card-right.vue?vue&type=template&id=4c2eccee"
import script from "./card-right.vue?vue&type=script&lang=ts"
export * from "./card-right.vue?vue&type=script&lang=ts"

import "./card-right.vue?vue&type=style&index=0&id=4c2eccee&lang=css"
script.render = render

export default script